var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-datepicker',{staticClass:"date-field",attrs:{"placeholder":_vm.$t('applications.choose')+' '+_vm.placeholder,"date-format-options":_vm.datepickerFormat},on:{"input":_vm.handleDatePick},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }